import React, { useEffect, useState } from 'react';
import { Col, Container, Row } from 'reactstrap';

//Import Breadcrumb
import Breadcrumbs from '../../components/Common/Breadcrumb';

//i18n
import { withTranslation } from 'react-i18next';
import { createSelector } from 'reselect';
import { getAllBookingDataLoading, getBookingFilterDataLoading, getTraxaaInternalUsersLoading } from 'store/actions';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import moment from 'moment';
import Spinners from 'components/Common/Spinner';
import BookingFilters from './BookingFilters';
import BookingGrid from './BookingGrid';

const Bookings = props => {
	//meta title
	document.title = 'Bookings';

	const [selectedMonth, setSelectedMonth] = useState(moment(new Date()).format('YYYY-MM'));
	const [selectedTab, setSelectedTab] = useState('ALL');
	const [isFilterModelOpen, setIsFilterModelOpen] = useState(false);

	const BookingsProperties = createSelector(
		state => state.Bookings,
		bookings => ({
			isLoading: bookings.bookings_data_loading,
			dataValue: bookings.bookings_data,
			isbookingFilterLoading: bookings.booking_filter_data_loading,
			bookingFilterData: bookings.booking_filter_data
		})
	);

	const FiltersProperties = createSelector(
		state => state.BookingFilters,
		filters => ({
			selectedFilters: filters.filters
		})
	);

	const { isLoading, dataValue, isbookingFilterLoading, bookingFilterData } = useSelector(BookingsProperties);
	const { selectedFilters } = useSelector(FiltersProperties);

	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(getBookingFilterDataLoading());
	}, [dispatch]);

	useEffect(() => {
		let newSelectedFilters = {};
		let isCountryFilterSelected = false;
		let selectedCountry = '';
		if (selectedFilters && selectedFilters.length > 0) {
			selectedFilters.map(f => {
				newSelectedFilters[f.type] = f.value;
			});
		}

		dispatch(
			getAllBookingDataLoading({
				...newSelectedFilters
			})
		);
		if (isCountryFilterSelected) {
			dispatch(
				getBookingFilterDataLoading({
					filterWith: 'taskList',
					polCountry: selectedCountry
				})
			);
		}
	}, [selectedFilters]);

	return (
		<React.Fragment>
			<div className="page-content">
				<Container fluid>
					{/* Render Breadcrumb */}
					<Breadcrumbs
						title={props.t('Bookings')}
						breadcrumbItem={props.t('Bookings (' + (dataValue?.statusData?.length || 0) + ')')}
					/>
					<Row>
						<Col xl="12">
							{!isbookingFilterLoading && isFilterModelOpen ? (
								<BookingFilters
									bookingFilterData={bookingFilterData}
									setIsFilterModelOpen={e => setIsFilterModelOpen(e)}
									//setSelectedFilters={e => setSelectedFilters(e)}
									selectedFilters={selectedFilters}
								/>
							) : null}
						</Col>
						<Col
							xl="12"
							style={isFilterModelOpen ? { opacity: 0.5, pointerEvents: 'none', userSelect: 'none', zIndex: -1 } : {}}
						>
							{isLoading ? (
								<Spinners setLoading={() => {}} />
							) : (
								<BookingGrid
									bookingsData={dataValue}
									isLoading={isLoading}
									setIsFilterModelOpen={e => setIsFilterModelOpen(e)}
									isFilterModelOpen={isFilterModelOpen}
									//setSelectedFilters={e => setSelectedFilters(e)}
									selectedFilters={selectedFilters}
									internalUsersList={[]}
									t={props.t}
								/>
							)}
						</Col>
					</Row>
				</Container>
			</div>
		</React.Fragment>
	);
};

export default withTranslation()(Bookings);
